import type { CurrentUser } from "@/stores/auth";

/** Человекочитаемое имя пользователя для UI. Гость показывается как
 * «Гость» (а не как технический email guest_*@guest.local). */
export function userLabel(user: CurrentUser | null | undefined): string {
  if (!user) return "";
  if (user.is_guest) return "Гость";
  return user.display_name || user.email.split("@")[0] || "";
}
